import { jsx as _jsx } from "react/jsx-runtime";
import { TelemetryImage } from '@shared/components/telemetryImage';
import pdpPrivateBadge from '@shared/images/pdp-privateBadge.svg';
import React from 'react';
export const PrivatePlanBadge = ()=>{
    return /*#__PURE__*/ _jsx(TelemetryImage, {
        src: pdpPrivateBadge,
        alt: "Private plan badge"
    });
};
